/**
 * Autenticación por credenciales contra el backend.
 *
 * Vía heredada: el acceso real del sistema es el popup de Google
 * (`LoginFirebaseService`), porque el backend valida un ID token de Firebase en
 * cada petición.
 *
 * Capa de servicios: una función por operación del API. No lanza nunca —cada
 * función devuelve un valor neutro ante el fallo—, así que el llamador debe
 * comprobar el resultado, no envolver en try/catch.
 */

export interface LoginResponse {
  status: boolean;
}

/**
 * Operación sobre login.
 *
 * @returns boolean
 */
export async function loginService(email: string, password: string, url: string): Promise<boolean> {
    const rawResponse = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({ email, password })
    });

    if (!rawResponse.ok) throw new Error(`HTTP error! status: ${rawResponse.status}`);

    const json = (await rawResponse.json()) as LoginResponse;

    return json.status;
}
